<template>
  <div class="dutyInfo">
    <div class="title">问诊时间设置</div>
    <PlanVideo />

    <!-- <div class="title">服务时间设置</div>
    <DoctorPlan /> -->

    <!-- <div class="title">服务类型及价格设置</div>
    <div class="type_info">
      <div class="serve_type">
        <el-table :data="typeList">
          <el-table-column label="标题" style="width: 10%" align="center">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column property="menusstate" label="状态" align="center">
            <template slot-scope="scope">
              <el-switch
                v-show="selectData === scope.row.id"
                v-model="scope.row.isOpen"
                active-value="1"
                inactive-value="0"
                @change="changeSwitch($event, scope)"
              />

              <span
                v-show="selectData !== scope.row.id"
                v-text="scope.row.isOpen == 1 ? '开启' : '关闭'"
              ></span>
            </template>
          </el-table-column>
          <el-table-column label="价格" style="width: 10%" align="center">
            <template slot-scope="scope">
              <el-input
                v-show="selectData === scope.row.id"
                v-model="scope.row.price"
                type="number"
                :min="0"
                :max="1000"
                >{{ scope.row.price }}</el-input
              >
              <span v-show="selectData !== scope.row.id"
                >{{ scope.row.price }}元</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                v-show="selectData !== scope.row.id"
                class="plan_btn"
                @click="editData(scope.row, scope.$index)"
                >编辑</el-button
              >

              <el-button
                type="primary"
                v-show="selectData === scope.row.id"
                class="plan_btn"
                @click="getType(scope.row)"
                >保存</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div> 

    <div class="title">
      擅长疾病 <span>请选择</span
      ><el-button
        @click="getDisease"
        style="padding: 5px; margin-left: 10px"
        icon="el-icon-plus"
      ></el-button>
    </div>

    <el-row style="width: 62%; margin-left: 30px; margin-top: 10px">
      <el-tag
        style="margin-right: 10px; margin-bottom: 10px"
        v-for="(tag, index) in diseaseTagList"
        :key="tag.id"
        :disable-transitions="false"
        @close="handleClose(tag, index)"
        closable
      >
        {{ tag.title }}
      </el-tag>
    </el-row>-->

    <!-- 弹窗 this.drugShow = true; -->
    <el-dialog :visible.sync="diagnoseResult" width="50%" center>
      <disease-adept
        @on_disease_code="on_disease_code"
        :departmentId="userInfo.departmentId"
      />
    </el-dialog>
  </div>
</template>

<script>
import DoctorPlan from '@/components/common/DoctorPlan';
import PlanVideo from '@/components/common/PlanVideo';
import {
  // getServiceList,
  getServiceType,
  getDiseaseListByDoctor,
  DiseaseDelete,
  getDoctorInformation,
} from '@/api';
import { getServiceList } from '@/api/doctor';
import diseaseAdept from '@/components/diseaseAdept';

export default {
  components: {
    DoctorPlan,
    diseaseAdept,
    PlanVideo,
  },
  data() {
    return {
      userInfo: {},
      form: {
        name: '',
      },
      isOpen: '',
      price: '',
      typeList: [],
      serviceId: '',
      selectData: ' ',
      diseaseTagList: [],
      diagnoseResult: false,
      row: {},
      closable: true,
    };
  },
  methods: {
    // 获取排期
    async setSchedule() {
      const params = {};
      const res = await setSchedule();
    },
    /**
     * @desc 个人信息回显
     */
    async getUserInfo() {
      try {
        const params = {};
        let { code, data } = await getDoctorInformation();
        if (code === 1) {
          this.userInfo = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 诊断结果
     */
    on_disease_code(data, type) {
      console.log('diseaseTagList', this.diseaseTagList);
      this.diagnoseResult = type;
      this.getDiseaseList();
    },
    getDisease() {
      this.diagnoseResult = true;
    },
    showNotice() {
      this.$notify({
        title: '提示',
        message: '必须确保您的服务信息是填写并保存成功的情况下才能接诊患者哦！',
        // duration: 0
      });
    },
    async getType(row) {
      console.log(this.typeList, row);
      try {
        let res = await getServiceType(row);
        console.log(res);
        if (res.success) {
          console.log(res);
          this.selectData = '';
          this.elementTips('success', res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    change: function (index, row) {
      console.log(index, row);
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    editData(row, index) {
      this.selectData = row.id;
    },
    async getTypeInfoTitle() {
      try {
        const params = {
          channelCode: 'lejian',
        };
        let res = await getServiceList(params);
        if (res.code == 1) {
          this.typeList = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 擅长疾病列表
    async getDiseaseList() {
      try {
        const params = { departmentId: this.userInfo.departmentId };
        let res = await getDiseaseListByDoctor(params);
        if (res.success) {
          console.log(res);
          this.diseaseTagList = res.result;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 擅长疾病删除
    async handleClose(tag, index) {
      const params = {
        id: tag.id,
      };
      let res = await DiseaseDelete(params);
      console.log(res);
      if (res.success) {
        this.getDiseaseList();
      } else {
        this.elementTips('error', res.message);
      }
    },
    changeSwitch(val, row) {
      console.log(val, row, this.typeList);
    },
    elementTips: function (type, message) {
      const $t = '';
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
  },

  mounted() {
    this.getUserInfo();
    // this.getTypeInfoTitle();
    this.showNotice();
    // this.getDiseaseList();
  },
};
</script>
<style lang="scss" scoped>
.name-wrapper {
  margin-left: -10px;
}
.dutyInfo {
  position: relative;
  width: 100%;
  margin: 20px;
  padding-bottom: 10px;
  box-shadow: 0 2px 12p#ebeef5;
  -webkit-box-shadow: 0 2px 12px 0 #ebeef5;
  .title {
    font-size: 16px;
    padding: 20px 0 0 20px;
    color: #333;
    span {
      margin-left: 10px;
      font-size: 12px;
    }
  }
  .plan_btn {
    width: 70px;
    height: 30px;
    line-height: 30px;
    padding: 0;
  }
  .type_info {
    position: relative;
    width: 60%;
    margin: 20px;
    .serve_type {
      width: 100%;
      display: flex;
      flex-direction: row;
      padding: 10px 0 0px 10px;
      border: 1px solid #ddd;
      box-shadow: 0 0 4px #ddd;
    }
  }
}
.reminder {
  position: absolute;
  font-size: 16px;
  display: inline-block;
  width: 305px;
  right: 20px;
  color: #666;
  line-height: 1.5;
  top: 60px;
}
.reminder i {
  color: red;
}
</style>
